export default "__VITE_ASSET__a47f2958__"